import { CircularProgress } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const StyledConnecting = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export interface ConnectingProps extends React.HTMLAttributes<HTMLDivElement> {}

const Connecting: React.FC<ConnectingProps> = ({ ...props }) => {
    return (
        <StyledConnecting {...props}>
            <CircularProgress />
        </StyledConnecting>
    );
};

export default Connecting;
